import type { DestinationMetadata } from '@/scopes/search/quick-search/domain/types'
import type { FilterOption } from '@/scopes/search/types'
import { DestinationFilterComponent } from '@/scopes/search/components/DestinationFilter'
import { destinationFilterOptionsSelector, isLoadingSelector } from '@/scopes/search/quick-search/components/selectors'
import { useQuickSearchSelector } from '@/scopes/search/quick-search/infrastructure/store/useQuickSearchSelector'
import * as React from 'react'

export function DestinationFilter({ onConfirm }: {
  onConfirm: (selection: FilterOption<string, DestinationMetadata> | undefined) => void
}) {
  const destinationOptions = useQuickSearchSelector(destinationFilterOptionsSelector)
  const isLoading = useQuickSearchSelector(isLoadingSelector)
  return (
    <DestinationFilterComponent
      onConfirm={onConfirm}
      options={destinationOptions.options}
      disabled={isLoading || destinationOptions.options.length === 0}
      selectedOption={destinationOptions.selectedDestination}
    />
  )
}
